import React from 'react';

export const ClickGesture = () => (
	<div className='custom-click-gesture'>
		<i className='mytabworks hand-pointer' />
	</div>
);
